import { SimStatusEnum } from '../enum/change_sim';
import { OrderStatusEnum } from '../enum/package_assigned';
import { IOrderStatus } from '../interface/package_assigned';

export const listPackageCode = [
  {
    value: '',
    label: 'Tất cả',
  },
  {
    value: 'A30',
    label: 'A30',
  },
  {
    value: 'A45',
    label: 'A45',
  },
];

export const orderStatus: IOrderStatus[] = [
  {
    value: '',
    label: 'Tất cả',
  },
  {
    value: OrderStatusEnum.New,
    label: 'New',
  },
  {
    value: OrderStatusEnum.Processing,
    label: 'Processing',
  },
  {
    value: OrderStatusEnum.Completed,
    label: 'Completed',
  },
  {
    value: OrderStatusEnum.Uncompleted,
    label: 'Uncompleted',
  },
  {
    value: OrderStatusEnum.Cancel,
    label: 'Canceled',
  },
  {
    value: OrderStatusEnum.Paid,
    label: 'Paid',
  },
  {
    value: OrderStatusEnum.PAYMENT_FAIL,
    label: 'Payment Fail',
  },
];
export const historyOrderStatus: IOrderStatus[] = [
  {
    value: '',
    label: 'Tất cả',
  },
  {
    value: SimStatusEnum.Success,
    label: 'Success',
  },
  {
    value: SimStatusEnum.Failed,
    label: 'Fail',
  },
  {
    value: SimStatusEnum.New,
    label: 'New',
  },
  {
    value: SimStatusEnum.Paid,
    label: 'Paid',
  },
  {
    value: SimStatusEnum.Processing,
    label: 'Processing',
  },
  {
    value: SimStatusEnum.Canceled,
    label: 'Canceled',
  },
];
